import Vue from 'vue';
import types from '../../mutation-types';

export const mutations = {
  [types.SET_LISTS_UI_FLAG]($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  [types.CLEAR_LISTS]($state) {
    Vue.set($state, 'records', {});
    Vue.set($state, 'sortOrder', []);
  },

  [types.SET_LIST_META]($state, data) {
    const { count, current_page: currentPage } = data;
    Vue.set($state.meta, 'count', count);
    Vue.set($state.meta, 'currentPage', currentPage);
  },

  [types.SET_LISTS]($state, data) {
    const sortOrder = data.map(list => {
      Vue.set($state.records, list.id, list);
      return list.id;
    });
    $state.sortOrder = sortOrder;
  },

  [types.SET_CURRENT_LIST]($state, data) {
    $state.currentList = data;
  },

  [types.CLEAR_LIST_MEMBERS]($state) {
    Vue.set($state, 'memberRecords', {});
    Vue.set($state, 'memberSortOrder', []);
  },

  [types.SET_LIST_MEMBER_META]($state, data) {
    const { count, current_page: currentPage } = data;
    Vue.set($state.memberMeta, 'count', count);
    Vue.set($state.memberMeta, 'currentPage', currentPage);
  },

  [types.SET_LIST_MEMBERS]($state, data) {
    const sortOrder = data.map(contact => {
      Vue.set($state.memberRecords, contact.id, contact);
      return contact.id;
    });
    $state.memberSortOrder = sortOrder;
  },
};
